import { Component, Input } from '@angular/core';

// Coloured status pill (Strong / Average / Low). Accepts an explicit
// status OR derives from a percentage. Used in My Tangrams + Media
// Type Performance tables.
@Component({
  selector: 'tangram-analytics-status-badge',
  template: `<span class="status-badge"
                   [class.status-top]="effectiveStatus === 'top'"
                   [class.status-mid]="effectiveStatus === 'mid'"
                   [class.status-low]="effectiveStatus === 'low'">{{ displayLabel }}</span>`,
  styleUrls: ['./analytics-status-badge.component.scss']
})
export class AnalyticsStatusBadgeComponent {
  @Input() status: 'top' | 'mid' | 'low' | null = null;
  @Input() percent: number | null = null;
  @Input() topThreshold = 70;
  @Input() midThreshold = 40;
  @Input() label: string | null = null;
  @Input() topLabel = 'Strong';
  @Input() midLabel = 'Average';
  @Input() lowLabel = 'Low';

  get effectiveStatus(): 'top' | 'mid' | 'low' {
    if (this.status) { return this.status; }
    const pct = this.percent || 0;
    if (pct >= this.topThreshold) { return 'top'; }
    if (pct >= this.midThreshold) { return 'mid'; }
    return 'low';
  }

  get displayLabel(): string {
    if (this.label !== null && this.label !== undefined) { return this.label; }
    if (this.percent !== null && this.percent !== undefined && this.label === null) {
      // Allow "{{ percent }}%" as the visible label when caller passes
      // percent only (matches Top/Lowest tangram badges).
      return `${this.percent}%`;
    }
    return this.effectiveStatus === 'top' ? this.topLabel
         : this.effectiveStatus === 'mid' ? this.midLabel
         : this.lowLabel;
  }
}
